var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagoneInfiltroReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.941,
    height: 242.941,
    viewBox: "0 0 242.941 242.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242.941,
    height: 242.941,
    rx: 55.382,
    ry: 55.382,
    fill: "#f60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.691,166.746c0,16.48-13.41,29.89-29.9,29.89s-29.89-13.41-29.89-29.89v-.18c.02-1.69.7-3.28,1.92-4.46,1.22-1.18,2.83-1.81,4.52-1.8,1.7.03,3.29.71,4.47,1.93,1.19,1.21,1.82,2.82,1.8,4.52,0,9.62,7.55,17.17,17.18,17.17s17.19-7.55,17.19-17.18c0-9.51-7.75-17.24-17.28-17.19-.27,0-.55-.02-.83-.05-.3.04-.59.06-.9.05h-36.38c-1.69-.02-3.28-.71-4.46-1.92-1.18-1.22-1.82-2.83-1.8-4.53.03-1.69.71-3.28,1.93-4.46,1.21-1.19,2.82-1.79,4.51-1.8h36.21c.31,0,.62.01.93.05.29-.04.6-.06.89-.05,16.48,0,29.89,13.41,29.89,29.9Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.131,148.636c0,18.48-15.04,33.52-33.52,33.52s-33.52-15.04-33.52-33.52v-.17c.02-1.7.71-3.28,1.92-4.47,1.22-1.18,2.84-1.79,4.52-1.8,1.7.03,3.29.71,4.47,1.93,1.19,1.22,1.83,2.82,1.8,4.52,0,11.46,9.34,20.79,20.81,20.79s20.8-9.33,20.8-20.8-9.33-20.81-20.8-20.81c-.31,0-.62-.01-.93-.05-.29.04-.61.05-.89.05H56.591c-1.69-.02-3.28-.71-4.46-1.92-1.18-1.22-1.82-2.83-1.8-4.53.03-1.69.71-3.28,1.93-4.46,1.21-1.19,2.8-1.81,4.51-1.8h105.03c.3,0,.61.01.92.05.3-.04.59-.05.9-.05,18.47,0,33.51,15.03,33.51,33.52Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.911,76.196c0,14.02-10.28,26.11-24.48,28.82-1.04.7-2.29,1.08-3.54,1.08H56.611c-1.71-.02-3.3-.71-4.48-1.92-1.18-1.22-1.82-2.83-1.8-4.53.03-1.69.71-3.28,1.93-4.46,1.22-1.19,2.85-1.79,4.52-1.8h74.23c9.48,0,17.19-7.71,17.19-17.19s-7.71-17.18-17.19-17.18-17.18,7.71-17.18,17.18v.17c-.03,1.7-.71,3.28-1.93,4.47-1.22,1.18-2.83,1.81-4.52,1.8-1.7-.03-3.29-.71-4.47-1.93-1.18-1.22-1.82-2.82-1.8-4.52,0-16.47,13.42-29.89,29.9-29.89s29.9,13.42,29.9,29.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagoneInfiltroReady);
export default __webpack_public_path__ + "static/media/hexagone-infiltro-ready.76d39b597e130ebf88ac4e095722c9ec.svg";
export { ForwardRef as ReactComponent };